export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=40ff8eba0a36c01792aa8785de1177884be64f548a&name=revalidateCommunity!'